import { Button, ModalV2, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';

const inputCls =
  'h-[38px] w-full border border-[#D2D8DF] rounded-lg px-3 text-[13px] text-[#353E4A] bg-white focus:outline-none focus:ring-2 focus:ring-[#FA3F58]/20';
const labelCls = 'text-[10px] font-semibold text-[#97A3B5] uppercase tracking-wide';

/**
 * Add a hard-blocked keyword — a shortcut over the Profanity term API with the
 * level forced to "high", for business-rule blocks (e.g. "crypto", "bitcoin")
 * that aren't profanity but should still block the post instantly.
 */
const KeywordModal = ({ visible, onClose, onSubmit, submitting }) => {
  const [text, setText] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (visible) {
      setText('');
      setError(null);
    }
  }, [visible]);

  const handleSubmit = () => {
    const trimmed = text.trim();
    if (!trimmed) {
      setError('Keyword is required.');
      return;
    }
    if (trimmed.length > 100) {
      setError('Keyword must be 100 characters or fewer.');
      return;
    }
    onSubmit({ term: trimmed });
  };

  return (
    <ModalV2
      visible={visible}
      closeModal={onClose}
      width="420px"
      header={
        <Text h4 bold marg="0">
          Add blocked keyword
        </Text>
      }
    >
      <div className="flex flex-col gap-4 p-6">
        <div className="flex flex-col gap-1">
          <label className={labelCls}>Keyword or phrase</label>
          <input
            type="text"
            value={text}
            onChange={(e) => {
              setText(e.target.value);
              setError(null);
            }}
            onKeyDown={(e) => e.key === 'Enter' && !submitting && handleSubmit()}
            placeholder="crypto"
            className={`${inputCls} font-mono`}
            autoFocus
          />
          <Text c1 col={theme.GREY_50} marg="2px 0 0" style={{ fontSize: '11px' }}>
            Blocks any shoutout, post, comment, or FanCam Challenge caption containing this word —
            instantly, no review. Use for business-rule blocks (crypto, gambling, etc.), not
            profanity — those belong in the Profanity tab.
          </Text>
        </div>

        {error && (
          <Text c1 col={theme.SECONDARY} marg="0" style={{ fontSize: '12px' }}>
            {error}
          </Text>
        )}

        <div className="flex justify-end items-center gap-2 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="h-[32px] px-4 rounded-full border border-[#D2D8DF] text-[13px] text-[#5F6F86] font-medium hover:bg-[#F0F2F4] transition-colors"
          >
            Cancel
          </button>
          <Button
            text="Add keyword"
            bg={theme.SECONDARY}
            small
            wid="130px"
            loading={submitting}
            disabled={submitting}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </ModalV2>
  );
};

export default KeywordModal;
